import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { ApiBaseUrl } from "../../http";
import { ITuto, TutoFormdata } from './tuto.type';
import { QueryUrl } from '../../Utils';

const TutoApi = createApi({
    reducerPath: "tutoApi",
    tagTypes: ["tuto"],
    baseQuery: fetchBaseQuery({
        baseUrl: `${ApiBaseUrl}/api/`,
        prepareHeaders,
    }),
    endpoints: (build) => ({
        AddOrUpdateTuto: build.mutation<
            ITuto,
            { slug?: string; data: ITuto | FormData }
        >({
            query: ({ slug, data }) => ({
                url: slug ? `accueil/${slug}/` : `accueil/`,
                method: slug ? "PUT" : "POST",
                body: data,
            }),
            invalidatesTags: ["tuto"],
        }),
        getTutos: build.query<PaginationResults<ITuto>, TypeQuery>({
            query: (query) => QueryUrl("accueil", query),
            providesTags: ["tuto"],
        }),
        getTutosProprietaire: build.query<PaginationResults<ITuto>, TypeQuery>({
            query: (query) => QueryUrl("tutos_proprietaire", query),
            providesTags: ["tuto"],
        }),
        getTutosProfessionnel: build.query<PaginationResults<ITuto>, TypeQuery>({
            query: (query) => QueryUrl("tutos_professionel", query),
            providesTags: ["tuto"],
        }),
        deleteTuto: build.mutation<TutoFormdata, string>({
            query: (slug) => ({
                url: `accueil/${slug}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["tuto"],
        }),
    }),
});

export default TutoApi

export const {
    useAddOrUpdateTutoMutation,
    useGetTutosQuery,
    useDeleteTutoMutation,
    useGetTutosProprietaireQuery,
    useGetTutosProfessionnelQuery,
} = TutoApi;